import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-chartjs-line',
  templateUrl: './chartjs-line.component.html',
  styleUrls: ['./chartjs-line.component.scss']
})
export class ChartjsLineComponent implements OnInit {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  @Input() chartHeight: any = 100; // Chart height in pixel
  @Input() showYAxisDollarValue: any = false; // Show $ sign for y axis vaules
  @Input() chartOptions: any = { // Chart options
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: true,
        grid: {
          display: false
        }
      },
      y: {
        display: true,
        grid: {
          display: false
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          boxWidth: 10,
          boxHeight: 1,
        }
      },
      tooltip: {
        enabled: true,
        displayColors: false
      }
    }
  };
  @Input() chartData: any; // Chart data

  public chartType: ChartType = 'line';
  public lineChartOptions: ChartConfiguration['options'];
  public lineChartData: ChartConfiguration['data'];

  constructor() { }

  ngOnInit(): void {
    // Set line chart options
    this.lineChartOptions = {
      responsive: this.chartOptions.responsive,
      maintainAspectRatio: this.chartOptions.maintainAspectRatio,
      scales: {
        x: {
          display: this.chartOptions.scales.x.display,
          beginAtZero: true,
          grid: {
            display: this.chartOptions.scales.x.grid.display
          }
        },
        y: {
          display: this.chartOptions.scales.y.display,
          beginAtZero: true,
          grid: {
            display: this.chartOptions.scales.y.grid.display
          }
        },
      },
      
      plugins: {
        legend: {
          display: this.chartOptions.plugins.legend.display,
          position: this.chartOptions.plugins.legend.position,
          labels: {
            boxWidth: this.chartOptions.plugins.legend.labels.boxWidth,
            boxHeight: this.chartOptions.plugins.legend.labels.boxHeight,
          }
        },
        tooltip: {
          enabled: this.chartOptions.plugins.tooltip.enabled,
          displayColors: this.chartOptions.plugins.tooltip.displayColors
        }
      }
    };

    // Show $ sign for y axis vaules
    if (this.showYAxisDollarValue) {
      // For y axis vaules
      this.lineChartOptions.scales.y.ticks = {
        callback: function(val, index) {
          return '$' + val
        }
      }

      // For tooltip values
      this.lineChartOptions.plugins.tooltip.callbacks = {
        label: function(context) {
          return '$' + context.formattedValue;
        }
      }
    }

    // Set line chart data
    this.lineChartData = this.chartData;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['chartData']) {
      this.lineChartData = this.chartData;
    }
  }


}
